<template>
	<div>
		<div class="jumbotron jumbotron-home has-image">
			<div class="container">
				<h1>{{$t('home.heading')}}</h1>
				<p class="lead">{{$t('home.lead2')}}</p>
			</div>
		</div>
		<Section :title="$t('home.issues')">
			<div class="card-body" slot="body">
				<p class="lead">{{$t('home.lead')}}</p>
			</div>
			<div slot="body">
				<div class="row row-cols-auto">
					<Treatments
						class="col-md-4"
						name="Sleep Issues"
						:items="['Insomnia', 'Nightsweats', 'Pain']" />
					<Treatments
						class="col-md-4"
						name="Mental Health"
						:items="['Depression', 'Anxiety']" />
					<Treatments
						class="col-md-4"
						name="Immune System"
						:items="['Frequent colds', 'Common Cold']" />
					<Treatments
						class="col-md-4"
						name="Digestive Disorders"
						:items="['Low or high appetite', 'Digestive discomfort', 'Gallstones', 'Nausea']" />
					<Treatments
						class="col-md-4"
						name="Women’s Health"
						:items="['Menstrual Disorders', 'Infertility', 'Menopause']" />
					<Treatments
						class="col-md-4"
						name="Musculoskeletal Issues"
						:items="['Low Back Pain', 'Hip Pain', 'Shoulder pain', 'Knee pain', 'Injury Rehabilitation']" />
					<Treatments
						class="col-md-4"
						name="Neurological Issues"
						:items="['Stroke Rehabilitation', 'Bell\'s Palsy', 'Balance Issues']" />
					<Treatments
						class="col-md-4"
						name="Cancer medication Side Effects"
						:items="['Chemotherapy induced Neuropathy', 'Nausea', 'Insomnia', 'Medication induced hot flashes', 'stress', 'anxiety']"
					/>
					<Treatments
						class="col-md-4"
						name="Others"
						:items="['Dry Eyes', 'Tinnitus', 'Headaches', 'Autoimmune Disorders']" />

				</div>
			</div>
			<BookNowButton class="mt-3" slot="body" />
		</Section>
		<Section title="Chinese Medicine">
			<p class="card-body" slot="body" v-html="$t('about.chineseMed')" />
			<p class="card-body" slot="body" v-html="$t('about.chineseMed2')" />
		</Section>
		<Section :title="$t('home.practitioner')">
			<div slot="body">
				<img
					:src="require('../../public/jessie.jpg')"
					alt=""
					class="thumbnail">
				<p>{{$t('about.practitioner')}}</p>
			</div>
		</Section>
		<Section title="Insurance">
			<div slot="body">
				<p>We do not accept insurance at this time</p>
			</div>
		</Section>
		<Section>
			<p slot="body">We are dedicated to learning more about what inclusion means. We welcome all people to receive this medicine. We support Black Lives and the LGBTQ population. We are also educating ourselves more about what it means to support these communities. Please let us know how we can be better too!</p>
		</Section>
		<Section title="Location">
			<div slot="body" class="text-right">
				<div class="mapouter">
					<div class="gmap_canvas">
						<iframe src="https://maps.google.com/maps?q=448%20Colfax%20Ave,%20Grass%20Valley,%20CA%2095945&t=&z=15&ie=UTF8&iwloc=&output=embed" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
					</div>
				</div>
			</div>
		</Section>
	</div>
</template>
<script>
import Section from './Section'
import BookNowButton from './BookNowButton'
import Treatments from './Treatments'

export default {
	components: {
		BookNowButton,
		Section,
		Treatments
	}
}
</script>
